/**
 * Onboarding Modal Hook
 * Feature 024: Care Seeker Dashboard - First-time onboarding
 *
 * Manages the display state of the onboarding modal
 * Shows modal on first dashboard visit after welcome letter is dismissed
 */

import { useState, useEffect } from 'react';
import { useLocalStorage } from '@/shared/hooks/useLocalStorage';

export function useOnboardingModal() {
  const [onboardingDismissed, setOnboardingDismissed] = useLocalStorage('onboardingModalDismissed', false);
  const [welcomeLetterDismissed] = useLocalStorage('welcomeModalDismissed', false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Show onboarding modal if:
    // 1. Welcome letter has been dismissed (user has seen it)
    // 2. Onboarding hasn't been dismissed yet
    if (welcomeLetterDismissed && !onboardingDismissed) {
      setShowModal(true);
    }
  }, [welcomeLetterDismissed, onboardingDismissed]);

  const dismissModal = () => {
    setOnboardingDismissed(true);
    setShowModal(false);
  };

  return { showModal, dismissModal };
}
